import * as React from 'react'
import { CorporationSchema } from 'src/components/meta/schemas/corporation-schema'
import { FAQPageSchema } from 'src/components/meta/schemas/faq-page-schema'
import { SearchSchema } from 'src/components/meta/schemas/search-schema'
import { WebsiteSchema } from 'src/components/meta/schemas/webstie-schema'

export const Schemas: React.FC = () => {
  const isCSR = typeof window !== 'undefined'

  if (isCSR) {
    return null
  }

  return (
    <>
      <FAQPageSchema />
      <SearchSchema />
      <CorporationSchema />
      <WebsiteSchema />
    </>
  )
}
